document.addEventListener('alpine:init', () => {
    Alpine.data('filter', () => ({
        currentFilter: 'all',

        filtered: {
            [':class']: 'currentFilter.includes($el.dataset.org) || currentFilter.includes($el.dataset.team) || currentFilter.includes("all") ? "" : "--is-hidden"',
        },

        activeFilter: {
            [':class']: 'currentFilter.includes($el.dataset.filter) ? "--is-active" : ""',
        },

        // Inline Example
        // :class="filtered.includes($el.dataset.org) || filtered.includes('all') ? '' : '--is-hidden'"

        applyFilter() {
            this.currentFilter = this.$el.dataset.filter
        },
    }))
})
